import { Dispatch, SetStateAction } from "react";
import styled from "styled-components";
import { StudentPhoto } from "./StudentPhoto.js";
import { SessionInfo } from "../../TestResultsWrapper.js";
import { CoreModal } from "@verity/components/core";
import i18n from "../../../../i18n.js";
// All of this styling was done using styled components (if using VSCode, install the vscode-styled-components extension for easier use)
const PhotoWrapper = styled.div`
	display: flex;
	justify-content: space-evenly;
	gap: 24px;
`;

export const StudentIdPopup = (props: {
	session: Pick<SessionInfo, "uuid">;
	setPopupState: Dispatch<SetStateAction<boolean>>;
	popupState: boolean;
}) => {
	return (
		<CoreModal
			title={i18n.t("result.components.studentSelection.studentInfo.studentPopupTSX.idVeri")}
			onClose={() => props.setPopupState(false)}
			open={props.popupState}
			showBottomCloseButton
			minWidth={"532px"}
		>
			<PhotoWrapper>
				<StudentPhoto type={"studentId"} sessionUuid={props.session.uuid} />
				<StudentPhoto type={"studentPhoto"} sessionUuid={props.session.uuid} />
			</PhotoWrapper>
		</CoreModal>
	);
};

export default StudentIdPopup;
